import React, { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';

// Top-of-page clock bar. Renders only for hourly users (decided by the
// /api/timeclock/me response, which reads pay_type server-side).
export default function TimeClockBar() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  async function refresh() {
    const res = await apiFetch('/api/timeclock/me');
    if (res.ok) setStatus(await res.json());
  }
  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 60000); // keep the on-duty time fresh
    return () => clearInterval(t);
  }, []);

  async function act(path) {
    if (busy) return;
    setBusy(true);
    try {
      await apiFetch('/api/timeclock/' + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });
      await refresh();
    } finally { setBusy(false); }
  }

  if (!status || !status.can_clock) return null; // salaried / non-hourly: nothing.

  const onDuty = status.on_duty;
  const onBreak = status.on_break;
  const since = status.since ? new Date(status.since) : null;

  return (
    <div className="hq-clockbar">
      <div className="hq-clockbar-state">
        <span className={`hq-dot ${onDuty ? (onBreak ? 'hq-dot-break' : 'hq-dot-on') : 'hq-dot-off'}`} />
        {onDuty
          ? (onBreak ? 'On break' : 'On duty')
          : 'Off duty'}
        {onDuty && since && (
          <small> · since {since.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</small>
        )}
      </div>
      <div className="hq-clockbar-actions">
        {!onDuty && (
          <button className="hq-btn" disabled={busy} onClick={() => act('clock-in')}>Clock in</button>
        )}
        {onDuty && !onBreak && (
          <>
            <button className="hq-btn hq-btn-ghost" disabled={busy} onClick={() => act('break/start')}>Start break</button>
            <button className="hq-btn" disabled={busy} onClick={() => act('clock-out')}>Clock out</button>
          </>
        )}
        {onDuty && onBreak && (
          <>
            <button className="hq-btn" disabled={busy} onClick={() => act('break/end')}>End break</button>
            <button className="hq-btn hq-btn-ghost" disabled={busy} onClick={() => act('clock-out')}>Clock out</button>
          </>
        )}
      </div>
    </div>
  );
}
